"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoTokenBodyToJSON = exports.PromoTokenBodyFromJSONTyped = exports.PromoTokenBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function PromoTokenBodyFromJSON(json) {
    return PromoTokenBodyFromJSONTyped(json, false);
}
exports.PromoTokenBodyFromJSON = PromoTokenBodyFromJSON;
function PromoTokenBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'type': (0, _1.PromoTokenTypeFromJSON)(json['type']),
        'isEnabled': !(0, runtime_1.exists)(json, 'isEnabled') ? undefined : json['isEnabled'],
        'isBranded': !(0, runtime_1.exists)(json, 'isBranded') ? undefined : json['isBranded'],
        'targetUrl': !(0, runtime_1.exists)(json, 'targetUrl') ? undefined : json['targetUrl'],
        'couponCodes': !(0, runtime_1.exists)(json, 'couponCodes') ? undefined : json['couponCodes'],
        'qrImageUrl': !(0, runtime_1.exists)(json, 'qrImageUrl') ? undefined : json['qrImageUrl'],
        'expiresAt': !(0, runtime_1.exists)(json, 'expiresAt') ? undefined : json['expiresAt'],
        'maxLimit': !(0, runtime_1.exists)(json, 'maxLimit') ? undefined : json['maxLimit'],
    };
}
exports.PromoTokenBodyFromJSONTyped = PromoTokenBodyFromJSONTyped;
function PromoTokenBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'description': value.description,
        'type': (0, _1.PromoTokenTypeToJSON)(value.type),
        'isEnabled': value.isEnabled,
        'isBranded': value.isBranded,
        'targetUrl': value.targetUrl,
        'couponCodes': value.couponCodes,
        'qrImageUrl': value.qrImageUrl,
        'expiresAt': value.expiresAt,
        'maxLimit': value.maxLimit,
    };
}
exports.PromoTokenBodyToJSON = PromoTokenBodyToJSON;
